const SitesRequest = (token: string): Request => {
  return new Request(new URL('sites', import.meta.env.VITE_BACKEND_URL), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export default SitesRequest;
